import { useState, useEffect, useCallback } from 'react';
import { fetchNpsUnresolvedCount } from './npsApi';

const POLL_MS = 5 * 60 * 1000;

export function useNpsUnresolvedCount(enabled) {
  const [count, setCount] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const unresolved = await fetchNpsUnresolvedCount();
      if (unresolved !== null) setCount(unresolved);
    } catch {
      // ignore transient errors
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setCount(null);
      return undefined;
    }

    refresh();

    const intervalId = setInterval(refresh, POLL_MS);

    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    const onCountUpdate = (event) => {
      const unresolved = event?.detail?.unresolved;
      if (typeof unresolved === 'number') setCount(unresolved);
    };

    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', refresh);
    window.addEventListener('nps-unresolved-count', onCountUpdate);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', refresh);
      window.removeEventListener('nps-unresolved-count', onCountUpdate);
    };
  }, [enabled, refresh]);

  return count;
}
